import { createFileRoute } from '@tanstack/react-router'
import { SubmissionScreen } from '../features/reviews'

function Submission() {
  const { workspaceId, submissionId } = Route.useParams()
  return <SubmissionScreen workspaceId={workspaceId} submissionId={submissionId} />
}

export const Route = createFileRoute('/w/$workspaceId/reviews/$submissionId')({
  component: Submission,
})
